const formatMobileNumber = (mobileNum) => {
  if (mobileNum.startsWith("+971")) {
    return mobileNum;
  } else if (mobileNum.startsWith("971")) {
    return "+" + mobileNum;
  } else {
    return "+971" + mobileNum;
  }
};

export default formatMobileNumber;